import { useMutation } from "@tanstack/react-query";

import { ToastType } from "@/enums";
import { displayToast } from "@/utils/toast";

interface Body {
  provider?: string;
  prompt: string;
  messages: string[];
}

const useAIJSONSchemaAssistant = () =>
  useMutation(async (body: Body) => {
    try {
      const response = await fetch("https://hook.us1.make.com/ns5g45k7f52qixmhdexk848m5o7cydbn", {
        body: JSON.stringify({
          provider: body.provider,
          prompt: JSON.stringify(body.prompt),
          messages: JSON.stringify(body.messages),
        }),
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });
      const data = await response.json();
      if (response.ok) {
        return data;
      }
      displayToast(
        data.error || "Error generating JSON Schema. Please try again.",
        ToastType.error,
      );
    } catch {
      displayToast("Error generating JSON Schema. Please try again.", ToastType.error);
    }
  });

export { useAIJSONSchemaAssistant };
